import SEOHead from "@/components/base/SEOHead";
import HeroSection from "./components/HeroSection";
import FeaturedAnime from "./components/FeaturedAnime";
import CategoryTabs from "./components/CategoryTabs";
import LatestUpdates from "./components/LatestUpdates";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <main>
      <SEOHead
        title="51动漫官网 | 51动漫在线观看与51动漫下载 | 动漫全集免费下拉式追更"
        description="51动漫官网🎯提供51动漫在线观看和51动漫下载服务，涵盖动漫全集、⏰免费动漫资源，支持下拉式阅读，满足用户追更好看的日漫韩漫国漫需求。每日更新热门动漫，完全免费，无需注册。"
        keywords="51动漫官网,51动漫在线观看,51动漫下载,动漫在线,动漫全集,动漫免费,动漫下载,免费动漫,下拉式阅读,日漫,韩漫,国漫"
        canonicalUrl="https://www.51anime.com"
      />
      <HeroSection />
      <FeaturedAnime />
      <CategoryTabs />
      <LatestUpdates />
      <FAQSection />
      <CTASection />
    </main>
  );
}